import React, { useEffect, useMemo } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { appActions } from 'commons/reducer';
import { ReactReduxContext } from 'config/configureStore';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { clone } from 'utils/functions';
import { actionProps, selectState } from 'utils/reduxActions';
import { valueHasData } from 'utils/validationsHelper';

const SearchClientByName = function (props) {
  const { foundClients, actions, clientName, callback, loaders, sx = {}, disabled = false } = props;

  const loading = loaders['get-client-by-name'];

  const foundClientValue = useMemo(
    () => foundClients.find((client) => client?.name === clientName) ?? null,
    [foundClients, clientName],
  );

  useEffect(() => {
    // we use this to clear the suggestions from the client input
    actions.getClientsByName({});
  }, []);

  const handleChange = (e, val) => {
    callback(val?.name || '');
  };

  const handleInputChange = (e, value) => {
    if (valueHasData(value)) {
      actions.getClientsByName({ clientName: value });
    }
  };

  const handleDebounce = (e, value, reason) => {
    if (reason !== 'reset') {
      const interval = setTimeout(() => {
        handleInputChange(e, value);
      }, 1000);
      return () => clearTimeout(interval);
    }
    return null;
  };

  return (
    <Autocomplete
      disablePortal
      id="clientName"
      loading={loading}
      autoComplete
      filterOptions={(x) => x}
      value={foundClientValue}
      options={foundClients}
      getOptionLabel={(opt) => `${opt.name}`}
      sx={sx}
      onInputChange={handleDebounce}
      onChange={handleChange}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...params}
          label="Buscar por Nombre Cliente"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      noOptionsText="Sin opciones"
    />
  );
};

const withConnect = connect(
  selectState('app.foundClients', 'app.loaders'),
  actionProps(clone(clone.OBJECT, appActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withConnect)(SearchClientByName);
